import type { ApolloError } from '@apollo/client';

/**
 * Extracts the GraphQL error or network error from an ApolloError.
 * ApolloError can contain many types of errors, this extracts only the ones we care about.
 * @param apolloError - The ApolloError to extract the error from.
 */
export const getErrorFromApolloError = (apolloError: ApolloError) => {
  const graphQLError = apolloError.graphQLErrors?.[0];
  const networkError = apolloError.networkError;
  return graphQLError ?? networkError ?? null;
};
